export var SAVE_WORKSPACE = 'SAVE_WORKSPACE';
export var SET_ACTIVE_TOOL = 'SET_ACTIVE_TOOL';
export var SET_API = 'SET_API';
export var SET_COMMAND_HISTORY_STORAGE = 'SET_COMMAND_HISTORY_STORAGE';
export var SET_DASHBOARD_STORAGE = 'SET_DASHBOARD_STORAGE';
export var SET_FILE_STORAGE = 'SET_FILE_STORAGE';
export var SET_PLUGINS = 'SET_PLUGINS';
export var SET_USER = 'SET_USER';
export var SET_WORKSPACE = 'SET_WORKSPACE';
export var SET_DEFAULT_WORKSPACE_SETTINGS = 'SET_DEFAULT_WORKSPACE_SETTINGS';
export var SET_WORKSPACE_STORAGE = 'SET_WORKSPACE_STORAGE';
export var SET_SERVER_CONFIG_VALUES = 'SET_SERVER_CONFIG_VALUES';
//# sourceMappingURL=actionTypes.js.map